import { render, staticRenderFns } from "./FilingData.vue?vue&type=template&id=62b08816&"
import script from "./FilingData.vue?vue&type=script&lang=js&"
export * from "./FilingData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports